import {
    BonusActivePanelLotsWagerContentStyled,
    BonusActivePanelTitleCanceledStyled,
    BonusActivePanelTitleWageredStyled
} from "./styled/BonusActivePanelStyled.js";
import { BONUS_STATUSES } from "../../bonusesConstants.js";
import LotsLegendLine from "./components/LotsLegendLine/LotsLegendLine.jsx";
import { useCalcLotsParams } from "./bonusActivePanelHooks.js";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function BonusActivePanelLotsWagerContent(props) {
    const {bonus, flat} = props;
    const {lotsLeft, percentValueLeft} =
            useCalcLotsParams(bonus?.amount || 0, bonus?.current_lots_amount || 0);
    const {getLangPath} = useLangContext();

    return <BonusActivePanelLotsWagerContentStyled flat={flat}>
        {
                bonus.status === BONUS_STATUSES.WAGERED && (
                        <BonusActivePanelTitleWageredStyled>
                            {getLangPath('bonuses.got_bonus')}
                        </BonusActivePanelTitleWageredStyled>
                )
        }
        {
                bonus.status === BONUS_STATUSES.ACTIVE && (
                        <>
                            <LotsLegendLine percent={percentValueLeft} amount={lotsLeft}>
                                {getLangPath('bonuses.lots_left')}
                            </LotsLegendLine>
                        </>
                )
        }
        {
                ![BONUS_STATUSES.ACTIVE, BONUS_STATUSES.WAGERED].includes(bonus.status) && (
                        <BonusActivePanelTitleCanceledStyled>
                            {getLangPath('bonuses.bonus_deactivated')}
                        </BonusActivePanelTitleCanceledStyled>
                )
        }
    </BonusActivePanelLotsWagerContentStyled>;
}

export default BonusActivePanelLotsWagerContent;
